<template>
    <div v-if="!discontinued" class="product" :class="[ min_height ]">
        <div class="product__copy">
            <p class="product__category">{{ cat }}</p>
            <p class="product__sub-text" v-if="subText && !prot">{{ subText }}</p>
            <p v-else />
        </div>

        <div class="product__image-wrapper">
            <img class="product__image" :src="image_source_url" @load="image_loaded = true" :class="{ visible: image_loaded }">
        </div>

        <div class="product__details">
            <div>
                <p class="product__sub-text" v-if="subText && prot">{{ subText }}</p>
                <h3 class="product__brand" v-if="brand">{{ brand }}</h3>
                <h3 class="product__name">{{ name }}</h3>
                <p class="product__price">${{ price }}.00</p>
                <button class="button product__cta" @click="addToBag">{{ orderable ? 'Add to Bag' : 'Add to Wishlist' }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { bus } from '../utilities'
import { product, shopping, user } from 'shiseido-apis'

export default {
    name: 'Product',
    props: {
        upc: {
            type: String,
            required: true,
        },
        cat: {
            type: String,
            default: () => '',
        },
        prot: {
            type: Boolean,
            default: () => false,
        },
        subText: {
            type: String,
            default: () => '',
        },
        noMinHeight: {
            type: Boolean,
            default: () => false,
        },
    },
    data() {
        return {
            name: '',
            price: 0,
            brand: '',
            image_source_url: '',
            orderable: false,
            discontinued: false,
            image_loaded: false,
        }
    },
    computed: {
        min_height() {
            return this.noMinHeight ? '--no-min-height' : ''
        },
    },
    created() {
        product.getShiseidoProductDetails(this.upc, { timeout: 20000 })
            .then((response) => {
                if (response.success === false) {
                    this.discontinued = true

                    console.warn(`Unable to retrieve product information for ${ this.upc }.`)
                    this.$emit('not-found')
                } else if (typeof response.fault === 'undefined') {
                    this.price = response.price
                    this.name = response.name
                    this.brand = response.brand
                    this.orderable = response.inventory.orderable
                    this.image_source_url = response.image_groups.filter((g) => g.view_type === 'hi-res')[0].images[0].dis_base_link.concat('?sw=220&sh=280&fit=small')

                    this.discontinued = response.c_discontinued || false

                    bus.$emit('product::found_'.concat(this.orderable ? 'orderable' : 'unorderable'), this)
                }
            })
    },
    methods: {
        addToBag() {
            if (this.orderable) {
                shopping.addToCart(this.upc, 1)
            } else {
                if (!user.loggedIn()) {
                    window.history.pushState({}, '', `${ window.location.origin }?hashpath=${ this.$route.path }/#${ this.$route.path }`)
                }

                shopping.addToWishlist(this.upc)
            }
        },
    },
}
</script>


// WEBPACK FOOTER //
// source/app/js/components/product.vue